
import router from "@/router";
import {
  ref,
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
} from "vue";
import {
  technologicalFrontierData,
  getArticleByCategoryId,
  getBannerByPosition,
} from "../views/api/user";
export default defineComponent({
  //科技前沿页面
  setup() {
     // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
    //获取全局变量
    //  const name="科技前沿";
    const proxy = getCurrentInstance() as any;
    console.log("proxy11", proxy);
    //全局url
    const url = proxy.appContext.config.globalProperties.$url;
    let show = ref<any>(true);
    //全局语言
    if (window.sessionStorage.getItem("language") as string) {
      var lan = JSON.parse(proxy.appContext.config.globalProperties.$language);
    }
    if (lan == "EN") {
      show.value = false;
    } else {
      show.value = true;
    }

    let absorbData = ref([]);
    let skinCareData = ref([]);
    let InternationalData = ref([]);

    //获取吸收性卫生用品数据
    const absorb = async () => {
      if (lan == "EN") {
        const column = reactive({
          categoryId: 279268838695237,
        });
        const res = await getArticleByCategoryId.getData(column);
        absorbData.value = res.data.result;
        console.log("absorbData", absorbData);
      } else {
        const column = reactive({
          categoryId: 279227598872901,
        });
        const res = await getArticleByCategoryId.getData(column);
        absorbData.value = res.data.result;
        console.log("absorbData", absorbData);
      }
    };

    //获取皮费护理数据
    const skinCare = async () => {
      if (lan == "EN") {
        const column = reactive({
          categoryId: 279269689188677,
        });
        const res = await getArticleByCategoryId.getData(column);
        skinCareData.value = res.data.result;
        console.log("skinCareData", skinCareData);
      } else {
        const column = reactive({
          categoryId: 279227819045189,
        });
        const res = await getArticleByCategoryId.getData(column);
        skinCareData.value = res.data.result;
        console.log("skinCareData", skinCareData);
      }
    };

    //获取皮费护理数据
    const International = async () => {
      if (lan == "EN") {
        const column = reactive({
          categoryId: 279269812977989,
        });
        const res = await getArticleByCategoryId.getData(column);
        InternationalData.value = res.data.result;
        console.log("InternationalData", InternationalData);
      } else {
        const column = reactive({
          categoryId: 279227961606469,
        });
        const res = await getArticleByCategoryId.getData(column);
        InternationalData.value = res.data.result;
        console.log("InternationalData", InternationalData);
      }
    };

    //跳转文章
    const golink = (No, id, title, title2) => {
      if (No == 1) {
        //将absorbData值保存到本地
        window.sessionStorage.setItem(
          "absorbData",
          JSON.stringify(absorbData.value)
        );
      } else if (No == 2) {
        //将absorbData值保存到本地
        window.sessionStorage.setItem(
          "absorbData",
          JSON.stringify(skinCareData.value)
        );
      } else {
        //将absorbData值保存到本地
        window.sessionStorage.setItem(
          "absorbData",
          JSON.stringify(InternationalData.value)
        );
      }
      if (lan == "EN") {
        let name = "Latest Research";
        router.push({
          path: "/article/" + id + "/" + name + "/" + title + "/" + false,
        });
      } else {
        let name = "科技前沿";
        router.push({
          path: "/article/" + id + "/" + name + "/" + title + "/" + false,
        });
      }
    };

    onMounted(() => {
      absorb();
      skinCare();
      International();
    });

    return {
      absorb,
      skinCare,
      International,
      golink,
      show,
      absorbData,
      url,
      skinCareData,
      InternationalData,
    };
  },
});
